import { Component, OnInit, signal } from '@angular/core';

import { IStrapiDocuments, Partner } from 'src/app/interfaces/strapi';

import StrapiService from 'src/app/services/strapi.service';
import { ActivatedRoute } from '@angular/router';
import { NgIf } from '@angular/common';
import { AuthService } from '../../../services/auth.service';
import { PageRetrievalErrorComponent } from '../../../shared/components/page-retrieval-error/page-retrieval-error.component';
import { RenderMarkdownComponent } from '../../../shared/components/render-markdown/render-markdown.component';

@Component({
    selector: 'app-partner-page',
    templateUrl: './partner-page.component.html',
    styleUrls: ['./partner-page.component.scss'],
    imports: [
        NgIf,
        PageRetrievalErrorComponent,
        RenderMarkdownComponent,
    ],
})
export class PartnerPageComponent implements OnInit {
  public partner = signal<Partner | null>(null);

  public headingColor = signal('red');

  public pageRetrievalError = signal(false);

  private source: 'ACCOMMODATION' | 'UNIVERSITY' | undefined;

  constructor(
    public authService: AuthService,
    public strapi: StrapiService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const { source } = this.route.snapshot.queryParams;

    this.source = source;

    const partnerId =
      this.source === 'ACCOMMODATION'
        ? this.authService.currentUser?.accommodation.partner_link_uid
        : this.authService.currentUser?.university.partner_link_uid;

    if (!partnerId) {
      this.pageRetrievalError.set(true);
      return;
    }

    this.strapi
      .getDocumentByUID('partners', partnerId, { populate: '*' })
      .subscribe({
        next: (data: IStrapiDocuments<Partner>) => {
          if (data.data.length) {
            this.partner.set(data.data[0].attributes);
          } else {
            this.pageRetrievalError.set(true);
          }
        },
        error: () => {
          this.pageRetrievalError.set(true);
        },
      });
   }
 }
